import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["inverse", "disabled", "colors", "className", "children", "clsPrefix", "style", "onChange"];

var _dec, _class;

import "core-js/modules/es6.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import omit from 'omit.js';
var propTypes = {
  /**
    * radio 颜色 样式
    */
  colors: PropTypes.oneOf(['', 'dark', 'success', 'info', 'warning', 'danger', 'primary']),

  /**
    * radio 大小
    */
  size: PropTypes.oneOf(['lg', 'sm', 'small', 'large', 'default']),

  /**
    * radio 是否可用
    */
  disabled: PropTypes.bool,

  /**
    * radio 样式 是否使用红色填充
    */
  inverse: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,

  /**
    * 是否兼容ant design模式
    */
  antd: PropTypes.bool
};
var sizeMap = {
  lg: 'lg',
  sm: 'sm',
  small: 'sm',
  default: 'sm',
  large: 'lg'
};
var defaultProps = {
  inverse: false,
  disabled: false,
  antd: false
};
/**
 * 建立与RadioGroup通信
 */

var contextTypes = {
  radioGroup: PropTypes.object
};
var Radio = (_dec = WebUI({
  name: "radio",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Radio, _React$Component);

  var _super = _createSuper(Radio);

  function Radio(props, context) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      if (_this.props.disabled) {
        return;
      }

      var antd = _this.props.antd;

      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
        var val = _this.props.value;

        if (antd) {
          var isBool = typeof _this.props.value === 'boolean';

          if (isBool) {
            event.isBool = true;
          }

          val = event;
        }

        _this.context.radioGroup.onChange(val);
      } else {
        if (!('checked' in _this.props)) {
          _this.setState({
            checked: !_this.state.checked
          });
        }

        event.target.checked = !_this.state.checked;
        _this.props.onChange && _this.props.onChange(event, !_this.state.checked);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      if (e.target && e.target.type == 'radio') {
        _this.setState({
          focused: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      if (e.target && e.target.type == 'radio') {
        _this.setState({
          focused: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      if (e.target && e.target.type == 'radio') {
        _this.setState({
          hovered: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (e) {
      if (e.target && e.target.type == 'radio') {
        _this.setState({
          hovered: false
        });
      }
    });

    var initChecked = typeof props.checked !== 'undefined' ? props.checked : props.defaultChecked;
    _this.state = {
      checked: initChecked,
      focused: false,
      hovered: false
    };
    return _this;
  }

  _createClass(Radio, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var state = this.state,
          props = this.props,
          context = this.context;
      var checked = state.checked;
      /**
       * 自身的属性
       */

      var inverse = props.inverse,
          disabled = props.disabled,
          colors = props.colors,
          className = props.className,
          children = props.children,
          clsPrefix = props.clsPrefix,
          style = props.style,
          onChange = props.onChange,
          others = _objectWithoutProperties(props, _excluded);

      var radioGroup = context.radioGroup;

      var radioProps = _objectSpread({}, others); // 包裹 radioGroup


      if (radioGroup) {
        radioProps.name = radioGroup.name;
        radioProps.selectedvalue = radioGroup.selectedValue;
        radioProps.size = radioGroup.size;
        radioProps.focusvalue = radioGroup.focusvalue;
      }

      var name = radioProps.name,
          selectedvalue = radioProps.selectedvalue,
          size = radioProps.size,
          focusvalue = radioProps.focusvalue;
      var optional = {};
      /**
       * 若父级selectedValue与本身的value值相同，则改radio被选中
       */

      if (selectedvalue !== undefined) {
        optional.checked = this.props.value === selectedvalue;
      }

      var classes = (_classes = {}, _defineProperty(_classes, "".concat(clsPrefix, "-focused"), this.state.focused), _defineProperty(_classes, "".concat(clsPrefix, "-hovered"), this.state.hovered), _defineProperty(_classes, 'is-checked', typeof optional.checked !== 'undefined' ? optional.checked : checked), _defineProperty(_classes, "disabled", disabled), _classes);

      if (colors) {
        classes["".concat(clsPrefix, "-").concat(colors)] = true;
      }

      if (sizeMap[size]) {
        classes["".concat(clsPrefix, "-").concat(sizeMap[size])] = true;
      }

      if (inverse) {
        classes["".concat(clsPrefix, "-inverse")] = true;
      } // if (children == null) {
      //   classes[`${clsPrefix}-noContent`] = true;
      // }


      var classNames = classnames(clsPrefix, classes);
      var tabIndex = optional.checked ? 0 : -1;

      if (focusvalue && focusvalue == this.props.value) {
        tabIndex = 0;
      }

      var input = /*#__PURE__*/React.createElement("input", _extends({}, omit(radioProps, ["antd"]), {
        type: "radio",
        name: name,
        disabled: this.props.disabled,
        tabIndex: tabIndex,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }));
      return /*#__PURE__*/React.createElement("label", {
        style: style,
        onClick: this.handleClick,
        className: classnames(className, classNames)
      }, input, /*#__PURE__*/React.createElement("label", {
        className: clsPrefix + '-label'
      }, children || /*#__PURE__*/React.createElement("span", {
        className: clsPrefix + '-label-no-content'
      }, "no children")));
    }
  }]);

  return Radio;
}(React.Component)) || _class);
Radio.contextTypes = contextTypes;
Radio.propTypes = propTypes;
export default Radio;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-radio/src/Radio.js